module.exports = __webpack_public_path__ + "img/bonus_dark_en.6c9fb193.png";